import React, { useEffect, useState } from 'react'
import Title from '../../../components/common/Title';
import { Topbar } from '../../../components/include/Topbar';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import HttpService from '../../../helpers/httpServices';
import { Postdata } from '../../../helpers/api.service';
import { message } from '../../../redux/actions/toastActions';
import Loader from '../../../components/common/Loader';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {  toast } from 'sonner'
import { useCountryNavigate } from '../../../components/common/UseCountryNavigate';

const AddContent = () => {
    const [formData, setFormData] = useState({
        title: "",
        text: "",
        type: "",
        image: null,
    })
    const [previewURL, setPreviewURL] = useState(null);
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const params = useParams();
    // const navigate = useNavigate();
    const navigate = useCountryNavigate();
    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState(false);
    
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Size check (10 MB)
        const maxSize = 5 * 1024 * 1024; // 10MB in bytes
        if (file.size > maxSize) {
            toast.warning('Image size should not exceed 5MB')
            return;
        }

        // Optional: Type check (only JPG, JPEG, PNG, WEBP)
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
        if (!allowedTypes.includes(file.type)) {
            toast.warning("Only JPG, JPEG, PNG, or WEBP formats are allowed")
            return;
        }

        setFormData((prev) => ({ ...prev, image: file }));
        setPreviewURL(URL.createObjectURL(file));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.title) newErrors.title = true;
        if (!formData.text) newErrors.text = true;
        if (!formData.type) newErrors.type = true;
        if (formData.type !== "school" && !formData.image) newErrors.image = true;


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let newValue = value;

        if (name === "type") {
            // Allow only letters, numbers, and underscore
            newValue = newValue.replace(/[^a-zA-Z0-9_]/g, "");
        }

        setFormData((prev) => ({ ...prev, [name]: newValue }));

    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;

        const form = new FormData();
        form.append("title", formData.title);
        form.append("text", formData.text);
        form.append("type", formData.type);
            form.append("image", formData.image);
        if (params.id) form.append("id", params.id);

        setLoader(true);
        Postdata(HttpService.admin_content_add, form).then((res) => {
            if (res.status === 200) {
                dispatch(message(res.message));
                navigate('admin-content');
            }

            setLoader(false);
        })
    }

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.admin_content_show, { id: params.id }).then((res) => {
            if (res.status === 200) {
                setFormData(res.data);
                if (res.data.image) {
                    setPreviewURL(res.data.image);
                }
            } else {
                dispatch(message(res.message));
            }
            setLoader(false);
        })
    }

    useEffect(() => {
        if (params.id) {
            fetchData();
        }
    }, [refresh])


    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }
    return (
        <div>
            <Title name=" Add Page" />
            <Topbar title={location.state?.type === "edit" ? "Edit Page" : "Add Page"} aerrow={true} />
            <div className="rounded-[20px]   m-4 "> {/* Added margin-bottom */}
                {/* Drag and Drop Area */}
                 <div className=" border-gray-300 bg-white  relative rounded-lg  text-center text-gray-500 hover:border-gray-400 transition duration-300 ease-in-out">
                    <input type="file" id="academic-calendar-upload" accept=".png,.jpg,.jpeg" className="hidden" />
                    <label className="flex flex-col items-center justify-center  border-purple-500 cursor-pointer overflow-hidden">
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                            className="hidden"
                        />
                        {console.log("previewURL", previewURL)}
                        {previewURL ? (
                            <div className=' relative h-[300px] w-full '>


                                <img
                                    src={previewURL || formData?.image}
                                    alt="Preview"
                                    className="w-full h-full object-cover rounded-xl "
                                />
                                <span className="text-white absolute top-[50%] left-[45%] z-10 font-medium">+ Upload Image</span>
                            </div>
                        ) : (
                            <span className="text-primary_main p-[130px] rounded-xl font-medium">+ Upload Image</span>
                        )}

                    </label>

                </div>
                {errors.image && (
                    <span className="text-red-500 text-sm">Required</span>
                )}


                {/* Upload Button */}
                <form onSubmit={handleSubmit}>



                    <div>
                        <label className="block mb-1 font-medium text-gray-700">
                            Page Title<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="title"
                            placeholder="Enter News Title"
                            className="input-field"
                            value={formData.title}
                            onChange={handleInputChange}
                        />
                        {errors.title && (
                            <span className="text-red-500 text-sm">Required</span>
                        )}
                    </div>
                    <div>
                        <label className="block mb-1 font-medium text-gray-700">
                            Page Type<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="type"
                            placeholder="Enter News Title"
                            className="input-field"
                            value={formData.type}
                            disabled={location.state?.type === "edit" ? true : false}
                            onChange={handleInputChange}
                        />
                        {errors.type && (
                            <span className="text-red-500 text-sm">Required</span>
                        )}
                    </div>
                    <div>
                        <label className="block mb-1 font-medium text-gray-700">
                            Text<span className="text-red-500">*</span>
                        </label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.text}
                            config={{
                                placeholder: "Write Here...",
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setFormData({ ...formData, text: data });
                            }}
                        />
                        {errors.text && (
                            <span className="text-red-500 text-sm">Required</span>
                        )}
                    </div>
                    <div className="w-full flex justify-center gap-3 mb-2 mt-4">
                        <button
                            type="submit"
                            className="button-field-primary"
                            style={{ width: "30%" }}
                        >
                            {loader ? 'Please wait...' : ('Submit')}
                        </button>
                    </div>
                </form>

            </div>
                        
        </div>
    )
}

export default AddContent